import React, { useState, useMemo, useEffect, Fragment, useRef } from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle';
import { wsGet, wsCreate, wsGetAll, wsRemove } from 'services/WService';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Toasty, useToasty } from 'hooks/Toasty';
import { makeStyles } from '@material-ui/core';
import { WithApp } from 'contexts/appContext';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment/moment';

// Components
import NewDepositCashAccount from './NewDeposit/NewDepositCashAccount';
import NewDepositHeader from './NewDeposit/NewDepositHeader';
import NewDepositChecks from './NewDeposit/NewDepositChecks';
import ImportDeposits from './NewDeposit/ImportDeposits';
import RegularButton from 'components/CustomButtons/Button';
import GridItem from 'components/Grid/GridItem';
import GridContainer from 'components/Grid/GridContainer';
import { wsPost, wsFindBy } from 'services/WService';

const defaultDeposit = {
  DeposType: 'C',
  DeposDate: moment().format('YYYY-MM-DD'),
  TaxDate: moment().format('YYYY-MM-DD'),
  BanckAcct: '',
  DpsBank: '',
  Memo: '',
  LocTotal: 0,
  Ref2: '',
  AllocAcct: '',
  U_SYP_MPPG: '001',
};

const useStyles = makeStyles(() => ({
  ...styles,
}));

function NewDeposit() {
  const { id } = useParams();
  const classes = useStyles();
  const navigate = useNavigate();
  const [notify, showNotify] = useToasty();
  const isDisabled = useMemo(() => !(parseInt(id) === 0), [id]);
  const [deposit, setDeposit] = useState(defaultDeposit);
  const [accountSap, setAccountSap] = useState([]);
  const [depositChecks, setDepositChecks] = useState([]);
  const [originAccounts, setOriginAccounts] = useState([]);
  const [bankAccounts, setBankAccounts] = useState([]);

  const inputFileRef = useRef(null);
  const [importData, setImportData] = useState(undefined);
  const [DataOperation, setDataOperation] = useState(undefined);
  const [uniqueTaxDates, setUniqueTaxDates] = useState([]);
  const [selectionModel, setSelectionModel] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [groupKey, setGroupKey] = useState(0);
  const [processing, setProcessing] = useState(false);
  const [validateExtracto, setValidateExtracto] = useState(false);
  const [alert, setAlert] = useState(null);
  const [mismatchIds, setMismatchIds] = useState(new Set());

  async function anulateDeposit() {
    setAlert(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title={`¿Está seguro de anular el depósito ${deposit.DpsBank} ${deposit.Memo}?`}
        onConfirm={async () => {
          setAlert(null);
          let res = await wsRemove('pymt/deposit', deposit.id);
          if (res.success) {
            showNotify(res.message);
            navigate('/admin/bancos/operaciones/depositos/');
          } else {
            showNotify(res.message, 'error');
          }
        }}
        onCancel={() => setAlert(null)}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      >
        Esta acción no se puede revertir
      </SweetAlert>,
    );
  }

  async function procesingDepositImport() {
    setAlert(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title={`¿Está seguro de procesar el depósito ${deposit.DpsBank} ${deposit.Memo}?`}
        onConfirm={async () => {
          setAlert(null);
          saveDeposit();
        }}
        onCancel={() => setAlert(null)}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      >
        Esta acción no se puede revertir
      </SweetAlert>,
    );
  }

  async function process() {
    if (deposit.BanckAcct?.length !== 8) {
      showNotify('Seleccione una cuenta destino', 'info');
      return;
    }

    if (deposit.DpsBank.length === 0) {
      showNotify('Ingrese el nombre del banco', 'info');
      return;
    }

    let data = { ...deposit };
    if (deposit.DeposType === 'C') {
      if (parseFloat(data.LocTotal) === 0) {
        showNotify('Ingrese el monto del déposito', 'info');
        return;
      }
      if (data.AllocAcct?.length !== 8) {
        showNotify('Seleccione una cuenta origen', 'info');
        return;
      }
      if (deposit.U_SYP_MPPG === '003' && data.AllocAcct === data.BanckAcct) {
        showNotify('No se puede seleccionar la misma cuenta para una transferencia de fondos', 'warning');
        return;
      }
    }

    if (deposit.DeposType === 'K') {
      delete data.AllocAcct;
      delete data.LocTotal;
      if (depositChecks.length === 0) {
        showNotify('Seleccione al menos un cheque', 'info');
        return;
      }
      data.checks = depositChecks;
    }

    let res = await wsCreate('pymt/deposit', data);
    if (res.success === false) {
      showNotify(res.message, 'error');
      return;
    }

    showNotify(res.message, 'success');
    setDeposit(defaultDeposit);
    setDepositChecks([]);
  }

  // function addGroup() {
  //   let selected = importData.filter((item) => selectionModel.includes(item.id));
  //   setSelectionModel([]);
  //   setSelectedGroups((groups) => {
  //     let newGroups = [...groups];
  //     newGroups.push({
  //       id: groupKey,
  //       items: selected,
  //       // Cuenta destino
  //       account: deposit.account,
  //       CtaDestino: deposit.CtaDestino,
  //       BanckAcct: deposit.BanckAcct,
  //       // Cuenta de origen
  //       CtaOrigen: deposit.CtaOrigen,
  //       AllocAcct: deposit.AllocAcct,
  //       DeposDate: deposit.DeposDate,
  //     });
  //     return newGroups;
  //   });
  //   setGroupKey((key) => key + 1);
  //   setImportData((importData) => {
  //     let newImportData = [...importData];
  //     newImportData = newImportData.filter((item) => !selectionModel.includes(item.id));
  //     return newImportData;
  //   });
  // }

  async function saveDeposit() {
    if (selectionModel.length === 0) {
      // alert('Seleccione al menos un registro para procesar');
      showNotify('Seleccione al menos un registro para procesar', 'warning');
      return;
    }

    setProcessing(true);

    // Armamos el payload en el formato que pide el back
    const itemsToSend = importData
      .filter(item => selectionModel.includes(item.id))
      .map(({ mismatchReason, ...item }) => ({
        ...item,
        CtaOrigen: deposit.CtaOrigen,
        AllocAcct: deposit.AllocAcct,
        DeposDate: deposit.DeposDate,
      }));

    const res = await wsPost('pymt/deposit/massive-store', {items: itemsToSend});

    if (res.success) {
      // alert(res.message);
      showNotify(res.message);
      window.location.href = '/admin/bancos/operaciones/depositos/';
    } else {
      setProcessing(false);
      // alert(res.message);
      showNotify(res.message, 'error');
    }
  }


  async function importExcel(e) {
    if (e.target.files.length === 0) {
      window.alert('Seleccione un archivo excel');
      e.target.value = '';
      return;
    }

    let formData = new FormData();
    formData.append('import', e.target.files[0]);

    setProcessing(true);
    let res = await wsCreate('pymt/deposit/store-excel', formData);
    setProcessing(false);
    inputFileRef.current.value = '';
    if (res.success) {
      const data = res.data.map((item, index) => ({ id: index, ...item }));
      setImportData(data);
      const fechas = [...new Set(data.map(item => item.TaxDate))];
      setUniqueTaxDates(fechas);
    } else {
      showNotify(res.message, 'error');
    }
  }

  useEffect(() => {
    wsGetAll('pymt/deposit/origin-accounts').then((res) => setOriginAccounts(res.data));
    wsGetAll('pymt/deposit/bank-accounts').then((res) => setBankAccounts(res.data));
    if (!isDisabled) return;
    wsGet('pymt/deposit', id).then((res) => {
      if (!res.success) return;
      let { checks, ...deposit } = res.data;
      deposit.DeposDate = moment(deposit.DeposDate).format('YYYY-MM-DD');
      deposit.TaxDate = moment(deposit.TaxDate).format('YYYY-MM-DD');
      setDeposit(deposit);
      setDepositChecks(checks || []);
    });
  }, []);

  useEffect(() => {
    if (deposit?.BanckAcct !== '') {
      setAccountSap([]);
      wsGetAll(`pymt/deposit/accounts-sap?BanckAcct=${deposit?.BanckAcct}`).then((res) => setAccountSap(res.data));
    }
  }, [deposit]);

  async function validateConciliation() {
    if (!importData || !DataOperation) return;

    const start_created_at = moment().subtract(30, 'days').format('YYYY-MM-DD');
    const end_created_at = moment().format('YYYY-MM-DD');

    let existingDeposits = [];
    try {
      const res = await wsFindBy('pymt/deposit', { start_created_at, end_created_at });
      if (res.success && Array.isArray(res.data)) {
        existingDeposits = res.data;
      }
    } catch (err) {
      console.error("Error obteniendo depósitos previos:", err);
    }

    // 🔧 Normalizadores (como ya tenías)
    const normalizeAccount = acc => acc?.replace(/[-\s]/g, '') ?? '';
    const normalizeNumber  = val => val == null || val === '' ? '' : parseInt(val, 10).toString();
    const normalizeAmount  = val => parseFloat(val ?? 0).toFixed(2);
    const normalizeDate    = val => val?.substring(0, 10) ?? '';

    const existingRefsSet = new Set(
      existingDeposits
        .map(dep => `${normalizeNumber(dep.Ref2)}|${normalizeDate(dep.TaxDate)}|${normalizeAmount(dep.LocTotal)}`)
        .filter(Boolean)
    );
    console.log("EXISTING REFS", existingRefsSet);

    const operationMap = new Map();
    DataOperation.forEach(op => {
      const key = `${normalizeAccount(op.account)}|${normalizeDate(op.TaxDate)}|${normalizeNumber(op.operation)}|${normalizeAmount(op.amount)}`;
      operationMap.set(key, op);
    });

    const mismatches = new Set();

    const updatedData = importData.map(row => {
      const rowKey = `${normalizeAccount(row.account)}|${normalizeDate(row.TaxDate)}|${normalizeNumber(row.Ref2)}|${normalizeAmount(row.LocTotal)}`;
      const ref2Key = `${normalizeNumber(row.Ref2)}|${normalizeDate(row.TaxDate)}|${normalizeAmount(row.LocTotal)}`;

      if (existingRefsSet.has(ref2Key) && row.sapAnnuled === null) {
        mismatches.add(row.id);
        return {
          ...row,
          mismatchReason: 'No concilio por: Referencia y/o monto registrado en los últimos 30 días',
          mismatchType: 'ref2'
        };
      }

      if (operationMap.has(rowKey)) {
        const { mismatchReason, ...rest } = row;
        return rest;
      }


      const candidate = DataOperation.find(op =>
        normalizeDate(op.TaxDate) === normalizeDate(row.TaxDate) &&
        normalizeAmount(op.amount) === normalizeAmount(row.LocTotal)
      );

      const reasons = [];

      if (candidate) {
        if (normalizeAccount(candidate.account) !== normalizeAccount(row.account)) {
          reasons.push('cuenta del depósito');
        }
        if (normalizeNumber(candidate.operation) !== normalizeNumber(row.Ref2)) {
          reasons.push('referencia (Nro Op)');
        }
      } else {
        const hasDate   = DataOperation.some(op => normalizeDate(op.TaxDate) === normalizeDate(row.TaxDate));
        const hasAmount = DataOperation.some(op => normalizeAmount(op.amount) === normalizeAmount(row.LocTotal));
        const hasAcc    = DataOperation.some(op => normalizeAccount(op.account) === normalizeAccount(row.account));
        const hasOp     = DataOperation.some(op => normalizeNumber(op.operation) === normalizeNumber(row.Ref2));

        if (!hasDate)   reasons.push('fecha del depósito');
        if (!hasAmount) reasons.push('monto');
        if (!hasAcc)    reasons.push('cuenta del depósito');
        if (!hasOp)     reasons.push('referencia (Nro Op)');
      }

      mismatches.add(row.id);
      return {
        ...row,
        mismatchReason: reasons.length > 0
          ? `No concilio por: ${reasons.join(', ')}`
          : 'No concilio por razones desconocidas'
        ,mismatchType: 'general'
      };
    });
    setValidateExtracto(mismatches.size === 0);
    setMismatchIds(mismatches);
    setImportData(() => {
      const arr = [...updatedData];
      arr.sort((a, b) => {
        const aMismatch = mismatches.has(a.id);
        const bMismatch = mismatches.has(b.id);
        if (aMismatch && !bMismatch) return -1;
        if (!aMismatch && bMismatch) return 1;
        return a.id - b.id;
      });
      return arr;
    });
    showNotify(
      mismatches.size === 0
        ? 'Todos los registros conciliaron'
        : `Se encontraron ${mismatches.size} sin conciliar`,
      mismatches.size === 0 ? 'success' : 'warning'
    );
  }

  return (
    <Fragment>
      <Toasty action={notify} />
      {alert}

      <input
        type="file"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        style={{ display: 'none' }}
        onChange={importExcel}
        ref={inputFileRef}
      />

      <CardContainer title={!isDisabled ? 'Nuevo deposito' : `Deposito ${id}`}>
        <NewDepositHeader
          depositId={id}
          importData={importData}
          onImport={() => {
            inputFileRef.current.click();
          }}
          saveDeposit={procesingDepositImport}
          DataOperation={DataOperation}
          setDataOperation={setDataOperation}
          taxDates={uniqueTaxDates}
          setTaxDates={setUniqueTaxDates}
          selectionModel={selectionModel}
          bankAccounts={bankAccounts}
          // onAddGroup={addGroup}
          deposit={deposit}
          accountSap={accountSap}
          validateOperation={validateConciliation}
          originAccounts={originAccounts}
          setDeposit={setDeposit}
          isDisabled={isDisabled}
          process={process}
          processing={processing}
          validateExtracto={validateExtracto}
        />
      </CardContainer>

      {importData === undefined && (
        <>
          {deposit.DeposType === 'K' && (
            <NewDepositChecks
              deposit={deposit}
              setDeposit={setDeposit}
              isDisabled={isDisabled}
              depositChecks={depositChecks}
              setDepositChecks={setDepositChecks}
            />
          )}

          {deposit.DeposType === 'C' && (
            <NewDepositCashAccount
              deposit={deposit}
              originAccounts={originAccounts}
              bankAccounts={bankAccounts}
              setOriginAccounts={setOriginAccounts}
              setDeposit={setDeposit}
              isDisabled={isDisabled}
            />
          )}
        </>
      )}

      {importData !== undefined && (
        <ImportDeposits
          importData={importData}
          setImportData={setImportData}
          // saveDeposit={saveDeposit}
          selectionModel={selectionModel}
          setSelectionModel={setSelectionModel}
          groups={selectedGroups}
          setGroups={setSelectedGroups}
          mismatchIds={mismatchIds}
          setValidateExtracto={setValidateExtracto}
        />
      )}

      {id !== '0' && (
        <GridContainer>
          <GridItem xs={12} sm={6} md={8} lg={10}></GridItem>
          <GridItem xs={12} sm={6} md={4} lg={2}>
            <RegularButton
              fullWidth
              color="danger"
              onClick={anulateDeposit}
              disabled={deposit.sapAnnuled !== null}
            >
              Anular
            </RegularButton>
          </GridItem>
        </GridContainer>
      )}
    </Fragment>
  );
}

export default WithApp(NewDeposit);
